:host {
    display: block;
  }

.hide-make-offer-button {
  display: block;
  min-height: 40px;
}

.components-container {
  min-height: 90px;
}

.sign-up-info  {
  min-height: 21px;
}

@media (max-width: 767px) {
  .hide-make-offer-button {
    display: none;
  }
}

.buyer-action-buttons {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  padding-top: 8px;
  min-height: 40px;
}

.buyer-action-buttons .action-button {
  padding-top: 0px;
  flex: 1;
  min-height: 40px;
}

.seller-details-small {
  display: none;
}

.seller-details {
  display: block;
}

.lower-section-details {
  min-height: 159px;
}

@media (min-width: 320px) and (max-width: 400px) {
  .buyer-action-buttons {
    flex-direction: column;
    gap: 0px;
    padding: 0px;
    min-height: 40px;
  }
  .buyer-action-buttons .action-button {
    padding-top: 8px;
    width: 100%;
    min-height: 40px;
  }
  .seller-details-small {
    display: block;
  }
  .seller-details {
    display: none;
  }
}

@media (min-width: 768px) and (max-width: 1299px) {
  .buyer-action-buttons {
    flex-direction: column;
    gap: 0px;
    padding: 0px;
    min-height: 100px;
  }
  .buyer-action-buttons .action-button {
    padding-top: 8px;
    width: 100%;
    min-height: 40px;
    min-width: 258px;
    flex: 0;
  }
  .seller-details-small {
    display: block;
  }
  .seller-details {
    display: none;
  }
  .sign-up-info  {
    min-height: 21px;
  }
  .components-container {
    min-height: 151px;
  }
}

